// 防止海外内网域名泄漏，使用prefix
export const Lemon8Host = {
  TEST_ROW_SURFIX: 'tiktok-row.net',
  TEST_VA_PREFIX: 'lemon8-v.byted',
  TEST_SG_PREFIX: 'lemon8.byted',
  ONLINE: 'www.lemon8-app.com',
};
